import { render, staticRenderFns } from "./CreateOptionsQuestionsVotesModal.vue?vue&type=template&id=62486160"
import script from "./CreateOptionsQuestionsVotesModal.vue?vue&type=script&lang=js"
export * from "./CreateOptionsQuestionsVotesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports